// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"f636e9e5","787":"d0a7efba"}[chunkId] + ".chunk.js";
};